import { render } from "./StockAttatchment.vue?vue&type=template&id=ac434adc&scoped=true&ts=true"
import script from "./StockAttatchment.vue?vue&type=script&lang=ts"
export * from "./StockAttatchment.vue?vue&type=script&lang=ts"

import "./StockAttatchment.vue?vue&type=style&index=0&id=ac434adc&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac434adc"]])

export default __exports__